module.exports = __webpack_public_path__ + "img/pencil.fa674205.svg";